function routeOptionKey(option: unknown): string {
  if (option == null || typeof option !== 'object') return '';
  const o = option as Record<string, unknown>;
  const name = typeof o.name === 'string' ? o.name : '';
  const encoded =
    typeof o.encoded_polyline === 'string' ? o.encoded_polyline : '';
  return `${name}\0${encoded}`;
}

function mergeRouteOptions(
  existing: unknown[],
  incoming: unknown[],
): unknown[] {
  const merged = [...existing, ...incoming];
  const seen = new Set<string>();
  const out: unknown[] = [];
  for (const option of merged) {
    const key = routeOptionKey(option);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(option);
  }
  return out;
}

/**
 * One segment per `(from_stop_id, to_stop_id)` after routing strategy is applied.
 */
export function normalizeRouteSegmentsForPersist(
  segments: Record<string, unknown>[],
): Record<string, unknown>[] {
  const byLeg = new Map<string, Record<string, unknown>>();

  for (const segment of segments) {
    const fromId = segment.from_stop_id;
    const toId = segment.to_stop_id;
    if (typeof fromId !== 'number' || typeof toId !== 'number') continue;

    const key = `${fromId}:${toId}`;
    const incomingOptions = Array.isArray(segment.route_options)
      ? segment.route_options
      : [];
    const existing = byLeg.get(key);

    if (!existing) {
      byLeg.set(key, {
        ...segment,
        from_stop_id: fromId,
        to_stop_id: toId,
        route_options: [...incomingOptions],
      });
      continue;
    }

    const existingOptions = Array.isArray(existing.route_options)
      ? existing.route_options
      : [];

    byLeg.set(key, {
      ...existing,
      ...segment,
      from_stop_id: fromId,
      to_stop_id: toId,
      route_options: mergeRouteOptions(existingOptions, incomingOptions),
    });
  }

  return [...byLeg.values()];
}

export function routeLegKey(
  fromStopId: number,
  toStopId: number,
): string {
  return `${fromStopId}:${toStopId}`;
}
